import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "native-base";
import { useState } from "react";
import { useFormContext } from "@madmedical/form";
import Checkbox from "../../../atoms/Checkbox";
import PreOpWrapper from "./PreOpWrapper";
const Statement = ({ onPreviousPress, onNextPress }) => {
    const [isChecked, setChecked] = useState(false);
    const { formState: { isSubmitting }, } = useFormContext();
    return (_jsx(PreOpWrapper, Object.assign({ onPreviousPress: onPreviousPress, onNextPress: onNextPress, isSubmitting: isSubmitting, isNextDisabled: !isChecked }, { children: _jsx(Box, Object.assign({ flex: 1, maxWidth: { base: "full", md: "1/2" }, mr: 10, p: {
                base: 4,
                md: 6,
            } }, { children: _jsx(Checkbox, Object.assign({ value: "statement", isChecked: isChecked, onChange: setChecked }, { children: "Kijelentem, hogy fenti adatok hitelesek, legjobb tud\u00E1som szerint v\u00E1laszoltam a k\u00E9rd\u00E9sekre, nem hallgattam el eg\u00E9szs\u00E9gi \u00E1llapotomat \u00E9rint\u0151 betegs\u00E9get, \u00E1llapotot, fogyat\u00E9koss\u00E1got." })) })) })));
};
export default Statement;
